import { useEffect, useRef, useState } from 'react';
//  ****** Swiper ****** //
import 'swiper/css/effect-coverflow';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
// ***** Custom component ***** //
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// ***** FontAwesome Icons ***** //
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';


//  ****** Static Image ***** //
import wingsGlobal from '../../assets/img/1.png';
import aircorps from '../../assets/img/2.png';
import platinum from '../../assets/img/3.png';
import forceAviation from '../../assets/img/4.png';
import rose from '../../assets/img/5.png';
import dDay from '../../assets/img/6.png';
import nwoc from '../../assets/img/7.png';
import adventure from '../../assets/img/8.png';
import museum from '../../assets/img/9.png';
import aeroscan from '../../assets/img/10.png';
import wingsNorth from '../../assets/img/11.png';
function OurTrustedPartner() {
  
  const prevRefTrusted = useRef(null);
  const nextRefTrusted = useRef(null);

const logos = [
  { src: wingsGlobal, alt: 'Wings Global Solutions' },
  { src: aircorps, alt: 'Aircorps Aviation' },
  { src: platinum, alt: 'Platinum Fighter Sales' },
  { src: forceAviation, alt: 'Force Aviation' },
  { src: rose, alt: 'Rose Aircraft Services' },
  { src: dDay, alt: 'D-Day Squadron' },
  { src: nwoc, alt: 'Northwest Warbird Collection' },
  { src: adventure, alt: 'Adventure Seaplanes' },
  { src: museum, alt: 'Military Aviation Museum' },
  { src: aeroscan, alt: 'Aeroscan' },
  { src: wingsNorth, alt: 'Wings of the North' },
 
];




  return (
    <>
      <section className="section">
      <h2 className="section__title section__title-gradient">Trusted By</h2>
      

        <div>
          <div className="swiper-container">
          <button
            ref={prevRefTrusted}
            className="products__btn products__btn--prev"
            type="button"
            aria-label="Previous slide"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <div className="container" style={{ marginTop: '1rem' }}>
            <Swiper
              modules={[Navigation]}
              loop={false}
              spaceBetween={80}
              slidesPerView={5}
              onSwiper={(swiper) => {
                setTimeout(() => {
                  swiper.params.navigation.prevEl = prevRefTrusted.current;
                  swiper.params.navigation.nextEl = nextRefTrusted.current;

                  swiper.navigation.destroy();
                  swiper.navigation.init();
                  swiper.navigation.update();
                });
              }}
              onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRefTrusted.current;
                swiper.params.navigation.nextEl = nextRefTrusted.current;
              }}
              breakpoints={{
                0: { slidesPerView: 1.2 },
                576: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1280: { slidesPerView: 4 },
              }}
            >
              {logos.map((logo) => (
              <SwiperSlide>
  <a href='#' target='_blank' rel='noopener noreferrer'>
    <div className='trustedSlide'>
      <img src={logo.src} alt={logo.alt} />
    </div>
  </a>
</SwiperSlide>

              ))}
            </Swiper>
          </div>
          <button
            ref={nextRefTrusted}
            className="products__btn products__btn--next"
            type="button"
            aria-label="Next slide"
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
        </div>
      </section>
    </>
  );
}
export default OurTrustedPartner;